import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header
      className={`${
        isSticky ? 'bg-white shadow-lg' : 'bg-white'
      } fixed top-0 left-0 right-0 z-50 transition-all duration-300`}
    >
      <nav className="max-w-6xl mx-auto flex justify-between items-center p-4">
        <div className="text-2xl font-semibold text-blue-600">
          <Link to="/">ChefLab</Link>
        </div>
        <div className="flex space-x-4">
          <Link
            to="/login"
            className="text-gray-700 hover:text-blue-600 transition duration-300"
          >
            Login
          </Link>
          <Link
            to="/register"
            className="text-gray-700 hover:text-blue-600 transition duration-300"
          >
            Register
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;
